import { monitorValue } from "../../util/monitorUtils";
const buildFailureMatrixData = (monitor) => {

    const matrix = {};

    for (let car = 1; car <= 8; car++) {

        matrix[car] = {

            ar: {

                active:
                    monitorValue(
                        monitor,
                        `arCondicionadoFalhaCarro${car}`,
                        0
                    ) !== 0,

                category:
                    monitor?.[
                        `arCondicionadoFalhaCarro${car}`
                    ]?.category,

                secondary:
                    monitorValue(
                        monitor,
                        `arCondicionadoAbaixo50Carro${car}`,
                        0
                    ) !== 0,

                secondaryCategory:
                    monitor?.[
                        `arCondicionadoAbaixo50Carro${car}`
                    ]?.category
            },

            luz: {

                active:
                    monitorValue(
                        monitor,
                        `iluminacaoFalhaCarro${car}`,
                        0
                    ) !== 0,

                category:
                    monitor?.[
                        `iluminacaoFalhaCarro${car}`
                    ]?.category,

                secondary:
                    monitorValue(
                        monitor,
                        `iluminacaoAbaixo50Carro${car}`,
                        0
                    ) !== 0,

                secondaryCategory:
                    monitor?.[
                        `iluminacaoAbaixo50Carro${car}`
                    ]?.category
            },

            midia: {

                active:
                    monitorValue(
                        monitor,
                        `multimidiaFalhaCarro${car}`,
                        0
                    ) !== 0,

                category:
                    monitor?.[
                        `multimidiaFalhaCarro${car}`
                    ]?.category,

                secondary: false
            }
        };
    }

    return matrix;
};
export default buildFailureMatrixData;